export type GetMarketStatusResponse = {
  data: MarketStatusData;
};
export type MarketStatusData = {
  otcBuyStatus: boolean;
  otcBuyDesc: string;
  otcSellStatus: boolean;
  otcSellDesc: string;
  usdtBuyPrice: number;
  usdtSellPrice: number;
};

export type GetMarketSelectorsResponse = {
  data: MarketSelectorsData[];
};

export type MarketSelectorsData = {
  id: string;
  NameFa: string;
  NameEn: string;
  symbol: string;
  logo: string;
  order: number;
  SubSelector: SubSelectorType[];
};

export type SubSelectorType = {
  id: string;
  nameFa: string;
  nameEn: string;
  symbol: string;
  logo: string;
  selectorId: string;
  order: number;
  Market: string;
  /** Set in the DB per market: `General`, `exchange`, `Technology`, … */
  category?: string;
  MarketInfo: {
    BuyStatus: boolean;
    SellStatus: boolean;
    Quote: string;
    Base: string;
    BuyDesc: string;
    SellDesc: string;
    MinSell: string;
    MaxSell: string;
    MinBuy: string;
    MaxBuy: string;
    Tick: string;
    Category: string;
    BasePrecision: number;
    QuotePrecision: number;
    DefaultQuoteValue: string;
    DefaultBaseValue: string;
    BuyVisibility: boolean;
    SellVisibility: boolean;
    RefSymbol: string;
    commissionPercentage: number;
  };
};

export type getOtcMarketTickerResponse = {
  data: getOtcMarketTickerData[];
};

export type getOtcMarketTickerData = {
  B: string;
  E: string;
  L: string;
  R: string;
  S: string;
  e: string;
  p: string;
  s: string;
};

export type ModalAssetType = {
  id: string;
  nameFa: string;
  nameEn: string;
  symbol: string;
  logo: string;
  status: boolean;
  visibility?: boolean;
  basePrecision?: number;
  quotePrecision?: number;
  minBuy?: string;
  minSell?: string;
  maxBuy?: string;
  maxSell?: string;
  isBuy?: boolean;
  mode?: 'buy' | 'sell';
  // price?: string;
  min?: string;
  max?: string;
  commissionPercentage?: number;
  market?: string;
  tick?: number;
  baseDefaultValue?: string;
  quoteDefaultValue?: string;
};

export type AssetWithMarketType = ModalAssetType & {
  basePrecision: number;
  quotePrecision: number;
  minBuy: string;
  minSell: string;
  maxBuy: string;
  maxSell: string;
  isBuy: boolean;
  mode: 'buy' | 'sell';
  price: string;
  precision: number;
  min: string;
  max: string;
};

export type OtcKlineRequest = {
  symbol: string;
  interval: string;
  limit: number;
  endTime: number;
};

export type OtcKlineItem = {
  symbol: string;
  time: string;
  open: string;
  close: string;
  low: string;
  high: string;
  volume: string;
  count: string;
};

export type OtcKlineResponse = {
  data: OtcKlineItem[];
};

type OtcStatusType =
  | 'STATUS_UNSPECIFIED'
  | 'STATUS_NEW'
  | 'STATUS_FAILED'
  | 'STATUS_COMPLETED';

type OtcSideType = 'SIDE_UNSPECIFIED' | 'SIDE_SELL' | 'SIDE_BUY';

/** Side codes the order-init endpoint expects. */
export enum OtcOrderSide {
  Sell = 1,
  Buy = 2
}

export type OtcOrderInitRequest = {
  qty: string;
  quoteQty: string;
  side: OtcOrderSide;
  base: string;
  quote: string;
  slippage: number;
};

export type OtcOrderInitResponse = {
  data: OtcResponseData;
};

export type OtcResponseData = {
  invoiceNumber: string;
  symbol: string;
  side: OtcSideType;
  base: string;
  quote: string;
  price: string;
  executedQty: string;
  cumulativeQuoteQty: string;
  feeQty: string;
  feeAsset: string;
  status: OtcStatusType;
  createTime: string;
  startTime: string;
  endTime: string;
  slippage?: number;
};
